export const footer = {
  copyright: "Copyright",
  faq: "FAQ",
  contact_us: "Kontaktiere uns",
  tos: "Nutzungsbedingungen",
  video_policy: "Videorichtlinie",
  privacy_policy: "Datenschutz-Bestimmungen",
  back_to_top: "ZURÜCK AN DIE SPITZE",
};
